import { $, $$ } from '@/utilities/helpers';
import { animate, scroll, inView } from "motion";

export function initSlideBackgroundAnimations() {
    if (!$('.slide')) {
        console.warn('No slide elements found for background animations.');
    }

    const slides = $$('.slide');
    slides.forEach((slide) => {
        const body = document.querySelector('body');
        const tag = slide.querySelector('.sparkle');

        let background;
        if (slide.classList.contains('theme--light')) {
            background = ["rgba(255,255,255, 1)"];
        } else if (slide.classList.contains('theme--dark')) {
            background = ["rgba(0,0,0,1)"];
        }

        repeatInView(
            slide,
            () => {
                animate(body,
                    { backgroundColor: background },
                    { duration: 0.4 }
                );

                if (slide.classList.contains('theme--light')) {
                    body.dataset.background = "light";
                } else if (slide.classList.contains('theme--dark')) {
                    body.dataset.background = "dark";
                }
            },
            {
                margin: "-40% 0px -55% 0px",
            }
        );
    });
}


// Motion's inView API doesn't let you repeat animations so have to create a custom repeatInView function
function repeatInView(element, callback, options = {}) {
    let observer;

    const observe = () => {
        observer = inView(element, (el, info) => {
            callback(el, info);

            return () => {
                setTimeout(observe, 0);
            };
        }, options);
    };

    observe();
    return () => observer && observer();
}


// scroll(animate('.features__line span', {
//     transform: ['scaleY(0%)', 'scaleY(100%)'],
// }, { delay: .02 }), {
//     target: $('.features__line').parentNode,
//     offset: ['start 50%', 'end 120%'],
// });



